export default "__VITE_ASSET__B13zVT6y__"